import React from 'react';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import Image from '../image';

function AppLogo(props: { height: number | string; width?: number | string }) {
  const { height } = props;

  const { appStore } = rootStore;
  const { customBranding } = appStore;

  return (
    <Image
      imageUrl={customBranding?.logo?.url ? customBranding?.logo?.url : 'app_logo'}
      alt={customBranding?.logo?.url ? 'logo' : 'teamcamp-logo'}
      height={height ? height : 60}
      width={60}
    />
  );
}

export default observer(AppLogo);
